/* ── Image paths (served from /public) ── */
export const IMGS = {
  i21: '/WhatsApp_Image_2026-03-23_at_10_11_21_AM.jpeg',
  i22: '/WhatsApp_Image_2026-03-23_at_10_11_22_AM.jpeg',
  i27: '/WhatsApp_Image_2026-03-23_at_10_11_27_AM.jpeg',
  i43: '/WhatsApp_Image_2026-03-23_at_10_11_43_AM.jpeg',
  i45: '/WhatsApp_Image_2026-03-23_at_10_11_45_AM.jpeg',
  i46: '/WhatsApp_Image_2026-03-23_at_10_11_46_AM.jpeg',
  i47: '/WhatsApp_Image_2026-03-23_at_10_11_47_AM.jpeg',
  i48: '/WhatsApp_Image_2026-03-23_at_10_11_48_AM.jpeg',
  i49: '/WhatsApp_Image_2026-03-23_at_10_11_49_AM.jpeg',
  i51: '/WhatsApp_Image_2026-03-23_at_10_11_51_AM.jpeg',
  i52: '/WhatsApp_Image_2026-03-23_at_10_11_52_AM.jpeg',
  i53: '/WhatsApp_Image_2026-03-23_at_10_11_53_AM.jpeg',
  i54: '/WhatsApp_Image_2026-03-23_at_10_11_54_AM.jpeg',
  i55: '/WhatsApp_Image_2026-03-23_at_10_11_55_AM.jpeg',
};

/* ── Featured Projects — 4 gallery images ── */
export const PROJECTS = [
  { img: '/WhatsApp_Image_2026-03-23_at_10_11_21_AM.jpeg', title: 'Tropical House', loc: 'Thrippunithura, Kochi' },
  { img: '/WhatsApp_Image_2026-03-23_at_10_11_46_AM.jpeg', title: 'Nestlent Villas', loc: 'Ponnani, Malappuram' },
  { img: '/WhatsApp_Image_2026-03-23_at_10_11_51_AM.jpeg', title: 'Nalukettu', loc: 'Guruvayur, Thrissur' },
  { img: '/WhatsApp_Image_2026-03-23_at_10_11_52_AM.jpeg', title: 'Contemporary Home', loc: 'Ponnani, Malappuram' },
];

export const GALLERY_IMGS = Object.values(IMGS);

export const SERVICES = [
  { num: '01', title: 'Architectural Design', text: 'Complete building design from master planning to detailed drawings, blending aesthetic vision with structural precision.', icon: 'Palace' },
  { num: '02', title: 'Interior Design', text: 'Thoughtfully curated interiors that reflect personality and elevate everyday living with premium finishes.', icon: 'Armchair' },
  { num: '03', title: 'Residential Homes', text: 'Custom luxury villas, traditional Kerala homes, and contemporary residences designed around your lifestyle.', icon: 'Home' },
  { num: '04', title: 'Master Planning', text: 'Site analysis, zoning, and comprehensive master planning for residential layouts and developments.', icon: 'Ruler' },
];

export const TESTIMONIALS = [
  { name: 'Anoop Krishnan', loc: 'Thrissur, Kerala', text: 'Nestlent transformed our vision of a traditional Kerala home into something truly breathtaking. Every detail was handled with exceptional care and craftsmanship.' },
  { name: 'Faisal Mohammed', loc: 'Malappuram, Kerala', text: 'The team at Nestlent was professional throughout the entire process. They listened to our needs and delivered beyond our expectations. Our dream home is now a reality.' },
  { name: 'Priya Nair', loc: 'Ponnani, Kerala', text: 'We were amazed by how seamlessly Nestlent integrated modern design with our love for traditional elements. The result is a home we are proud of every single day.' },
];

export const TIMELINE = [
  { year: '2016 · Founded', event: 'Nestlent is Born', desc: 'Established in Ponnani with a vision to redefine residential architecture in Kerala, blending heritage with contemporary sensibility.' },
  { year: '2018 · Milestone', event: '30 Projects Completed', desc: 'Celebrated the completion of our 50th residential project, establishing our reputation across Calicut and Ernakulam districts.' },
  { year: '2021 · Expansion', event: 'Interior Design Division Launched', desc: 'Extended services to include full interior design, bringing cohesive design language from architecture to the interiors of every home.' },
  { year: '2026 · Today', event: '70+ Happy Families', desc: 'Now proudly serving clients across Kerala with a growing portfolio of traditional and contemporary homes that stand as testaments to our craft.' },
];
